(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var consent = document.getElementById('ContactForm-privacy');
    var submit = document.getElementById('ContactForm-submit');
    var err = document.getElementById('ContactForm-privacy-error');

    function toggleSubmit() {
      var ok = consent && consent.checked;
      if (ok) {
        submit.removeAttribute('disabled');
        submit.setAttribute('aria-disabled','false');
        err && err.classList.remove('is-visible');
      } else {
        submit.setAttribute('disabled','disabled');
        submit.setAttribute('aria-disabled','true');
      }
    }
    if (consent && submit) {
      toggleSubmit();
      consent.addEventListener('change', toggleSubmit);
      form.addEventListener('submit', function(e){
        if (!consent.checked) {
          e.preventDefault();
          err && err.classList.add('is-visible');
          consent.focus();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Header sofort sticky machen wenn "always" oder "reduce-logo-size" ausgewählt
      if (this.headerIsAlwaysSticky && this.header) {
        this.header.classList.add('shopify-section-header-sticky');
        // Stelle sicher, dass der Header sofort sticky ist
        this.header.style.position = 'sticky';
        this.header.style.top = '0';
        this.header.style.zIndex = '3';
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      if (!this.searchModal) {
        this.searchModal = this.header ? this.header.querySelector('details-modal') : null;
      }
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // GA4 Navigation Tracking - Einzelne Events für jeden Reiter
  function trackNavigationClick(linkName, linkUrl, linkType = 'navigation') {
    if (typeof gtag !== 'undefined') {
      // Erstelle Event-Namen basierend auf Link-Name (kebab-case)
      const eventNameMap = {
        'Produkte': 'navigation_produkte_click',
        'Konfigurator': 'navigation_konfigurator_click',
        'So funktionierts': 'navigation_so_funktionierts_click',
        'Anwendungsbereiche': 'navigation_anwendungsbereiche_click',
        'Kontakt': 'navigation_kontakt_click',
        'Jetzt konfigurieren': 'navigation_jetzt_konfigurieren_click',
        'Account': 'navigation_account_click',
        'Warenkorb': 'navigation_warenkorb_click'
      };
      
      const eventName = eventNameMap[linkName] || 'navigation_click';
      
      gtag('event', eventName, {
        'event_category': 'navigation',
        'event_label': linkName,
        'link_name': linkName,
        'link_url': linkUrl,
        'link_type': linkType,
        'page_location': window.location.href
      });
    }
  }

  // Navigation Tracking initialisieren
  document.addEventListener('DOMContentLoaded', function() {
    // "Jetzt konfigurieren" Button
    const konfiguratorBtn = document.querySelector('.header__icon--konfigurator');
    if (konfiguratorBtn) {
      konfiguratorBtn.addEventListener('click', function(e) {
        trackNavigationClick('Jetzt konfigurieren', this.href || 'https://sicherungskasten24.de/pages/konfigurator', 'button');
      });
    }

    // Account Link
    const accountLink = document.querySelector('.header__icon--account');
    if (accountLink) {
      accountLink.addEventListener('click', function(e) {
        const linkText = this.querySelector('.visually-hidden')?.textContent?.trim() || 'Account';
        trackNavigationClick('Account', this.href, 'icon');
      });
    }

    // Warenkorb Link
    const cartLink = document.querySelector('.header__icon--cart, #cart-icon-bubble');
    if (cartLink) {
      cartLink.addEventListener('click', function(e) {
        trackNavigationClick('Warenkorb', this.href || '/cart', 'icon');
      });
    }

    // Funktion zum Hinzufügen von Tracking zu Links
    function addTrackingToLinks() {
      // Navigation Links im Menü (Desktop und Mobile)
      const navigationLinks = document.querySelectorAll('.header__inline-menu a, .menu-drawer__menu a, .list-menu a, .mega-menu__link, .header__menu-item');
      navigationLinks.forEach(link => {
        // Überspringe Links, die bereits getrackt werden
        if (link.dataset.trackingAdded) return;
        link.dataset.trackingAdded = 'true';
        
        const linkText = link.textContent.trim();
        const linkHref = link.getAttribute('href');
        
        // Prüfe auf spezifische Navigationselemente
        if (linkHref) {
          let linkName = null;
          
          // Prüfe basierend auf href
          if (linkHref.includes('/collections') || linkHref.includes('/products') || linkText.toLowerCase().includes('produkt')) {
            linkName = 'Produkte';
          } else if (linkHref.includes('/pages/konfigurator') || linkText.toLowerCase().includes('konfigurator')) {
            linkName = 'Konfigurator';
          } else if (linkHref.includes('/pages/so-funktionierts') || linkText.toLowerCase().includes('so funktioniert')) {
            linkName = 'So funktionierts';
          } else if (linkHref.includes('/pages/anwendungsbereiche') || linkText.toLowerCase().includes('anwendungsbereich')) {
            linkName = 'Anwendungsbereiche';
          } else if (linkHref.includes('/pages/contact') || linkHref.includes('/#contact') || linkText.toLowerCase().includes('kontakt')) {
            linkName = 'Kontakt';
          }
          
          // Wenn ein spezifischer Link gefunden wurde, Event hinzufügen
          if (linkName) {
            link.addEventListener('click', function(e) {
              trackNavigationClick(linkName, linkHref, 'menu');
            });
          }
        }
      });
    }

    // Initial Tracking hinzufügen
    addTrackingToLinks();

    // Beobachte Änderungen im DOM für dynamisch geladene Menüs (z.B. Mobile-Menü)
    const observer = new MutationObserver(function(mutations) {
      addTrackingToLinks();
    });

    // Beobachte den Header-Bereich auf Änderungen
    const headerElement = document.querySelector('header, .header__inline-menu, header-drawer');
    if (headerElement) {
      observer.observe(headerElement, {
        childList: true,
        subtree: true
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-konfigurator-demo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll(".mini-konfigurator-demo");
    if (!sections.length) {
      return;
    }

    const animatedSelector = [
      ".mini-konfigurator-demo__canvas-toolbar",
      ".mini-konfigurator-demo__row",
      ".mini-konfigurator-demo__toolbar-value",
      ".mini-konfigurator-demo__chip",
      ".mini-konfigurator-demo__cta"
    ].join(", ");

    const startAnimation = (sectionEl) => {
      sectionEl.classList.add("mini-konfigurator-demo--in-view");
    };

    const isElementInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    };

    if (!("IntersectionObserver" in window)) {
      for (const sectionEl of sections) {
        startAnimation(sectionEl);
      }
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) {
            continue;
          }

          startAnimation(entry.target);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -10% 0px"
      }
    );

    for (const sectionEl of sections) {
      if (isElementInViewport(sectionEl)) {
        startAnimation(sectionEl);
        continue;
      }

      observer.observe(sectionEl);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  // GA4 Hero Button Tracking
  document.addEventListener('DOMContentLoaded', function() {
    // Hero Buttons im Slideshow-Bereich finden
    const heroButtons = document.querySelectorAll('.slideshow .banner__buttons a.button');
    
    heroButtons.forEach(button => {
      const buttonText = button.textContent.trim();
      const buttonHref = button.getAttribute('href');
      
      // Prüfe auf spezifische Buttons
      if (buttonText === 'Jetzt konfigurieren' || buttonText.includes('konfigurieren')) {
        button.addEventListener('click', function(e) {
          if (typeof gtag !== 'undefined') {
            gtag('event', 'hero_jetzt_konfigurieren_click', {
              'event_category': 'hero',
              'event_label': 'Jetzt konfigurieren',
              'button_text': buttonText,
              'button_url': buttonHref || '',
              'page_location': window.location.href
            });
          }
        });
      } else if (buttonText === 'Zu den fertigen Kästen' || buttonText.includes('fertigen Kästen') || buttonText.includes('fertige Kästen')) {
        button.addEventListener('click', function(e) {
          if (typeof gtag !== 'undefined') {
            gtag('event', 'hero_zu_den_fertigen_kaesten_click', {
              'event_category': 'hero',
              'event_label': 'Zu den fertigen Kästen',
              'button_text': buttonText,
              'button_url': buttonHref || '',
              'page_location': window.location.href
            });
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
